import React from "react";
import { Helmet } from "react-helmet-async";
import useSectionScroll from "../../hooks/useSectionScroll";

export default function Hero() {
  const goToSection = useSectionScroll();

  return (
    <>
      <Helmet>
        <title>ZevixTech — Digital Products Engineered to Convert</title>

        <meta
          name="description"
          content="We design and build digital products that turn visitors into customers."
        />
      </Helmet>

      <section
        id="home"
        className="
          relative
          w-full
          overflow-hidden
          bg-[#F7F4EE]
          pb-12
          pt-24

          sm:pb-14
          sm:pt-28

          md:pb-12
          md:pt-32

          lg:pb-16
        "
      >
        {/* Background Glow */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at 80% 30%, rgba(200,118,42,.08), transparent 45%)",
          }}
        />

        {/* Main Container */}
        <div
          className="
            relative
            mx-auto
            w-full
            max-w-[2000px]
            px-4

            sm:px-6

            lg:px-12
          "
        >
          <div
            className="
              grid
              items-center
              gap-8

              sm:gap-10

              md:grid-cols-2
              md:gap-10

              lg:gap-14
            "
          >
            {/* Left Content */}
            <div className="min-w-0">
              {/* Heading */}
              <h1
                className="
                  mb-5
                  text-[36px]
                  font-bold
                  leading-[1.08]
                  tracking-tight
                  text-[#1A1714]

                  sm:text-5xl
                  sm:leading-[1.05]

                  md:text-[46px]

                  lg:mb-6
                  lg:text-6xl

                  xl:text-7xl
                "
              >
                Digital Products,
                <br />

                <span className="italic text-[#C8762A]">
                  Engineered to Convert
                </span>

                <br />

                Not Just Impress
              </h1>

              {/* Description */}
              <p
                className="
                  mb-7
                  max-w-xl
                  text-sm
                  leading-6
                  text-stone-600

                  sm:text-base
                  sm:leading-7

                  lg:mb-10
                  lg:text-lg
                  lg:leading-8
                "
              >
                From first wireframe to final pixel, we design and build digital
                products that turn visitors into customers—not just ones that
                look good in a portfolio.
              </p>

              {/* Buttons */}
              <div
                className="
                  flex
                  w-full
                  flex-col
                  gap-3

                  sm:w-auto
                  sm:flex-row
                  sm:gap-4
                "
              >
                <button
                  type="button"
                  onClick={() => goToSection("contact")}
                  className="
                    btn-dark
                    flex
                    w-full
                    items-center
                    justify-center

                    sm:w-auto
                  "
                >
                  Start Your Project
                </button>

                <button
                  type="button"
                  onClick={() => goToSection("portfolio")}
                  className="
                    btn-outline
                    flex
                    w-full
                    items-center
                    justify-center

                    sm:w-auto
                  "
                >
                  View Portfolio
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="min-w-0">
              <div
                className="
                  h-[240px]
                  w-full
                  overflow-hidden
                  rounded-2xl
                  border
                  border-[#D6CFBF]
                  shadow-lg

                  sm:h-[320px]
                  sm:rounded-3xl

                  md:h-[380px]

                  lg:h-[480px]
                  lg:shadow-xl

                  xl:h-[540px]
                "
              >
                <img
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuBa_WpUK3V2GZ4yFreC1K-0d686EzCAZq9za_-raST_J3RDnMFZ--nVUX1BfK5agkhcyNWBTiZMZmZEak4uB1DsMJtmU_H1FPiMGrHOQJ_ZOjuBhFZe0avxa6PXkHz70Xl3-Te68Sfbu85f2EM7HAXWsPRhgx_T6Jxo0UqfIl3nnFan0U_fiaOnyB_TlkvpHybndqqCCQab7BFmG61K-_6NEZE2eXEYjBqJ3uJy183E33r6QF6PglJT0AsmU60htXKP2WwSfqJAXC4"
                  alt="Digital product design and development preview"
                  loading="eager"
                  className="
                    block
                    h-full
                    w-full
                    object-cover
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
} 